import { KEY_CODES } from '../util';

class Menu {
  constructor(classname) {
    this.classname = classname;

    this.body = document.querySelector('body');
    this.menu = document.querySelector(`${this.classname}`);
    this.menuOpen = document.querySelector(`${this.classname}-open`);
    this.menuClose = document.querySelector(`${this.classname}-close`);

    // Set focusable elements
    this.focusableEls = [this.menuClose, ...Array.from(this.menu.querySelectorAll('a'))];
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.bindEvents();
  }

  bindEvents() {
    this.menuOpen.addEventListener('click', () => this.open());
    this.menuClose.addEventListener('click', () => this.close());
  }

  open() {
    this.menu.removeAttribute('aria-hidden');
    this.menu.classList.add('active');
    this.body.classList.add('inactive');
    this.menuClose.focus();
    document.addEventListener('keydown', e => this.keydown(e));
  }

  close() {
    this.menu.setAttribute('aria-hidden', true);
    this.menu.classList.remove('active');
    this.body.classList.remove('inactive');
    this.menuOpen.focus();
    document.removeEventListener('keydown', e => this.keydown(e));
  }

  handleBackwardTab(e) {
    if (document.activeElement === this.firstFocusableEl) {
      e.preventDefault();
      this.lastFocusableEl.focus();
    }
  }

  handleForwardTab(e) {
    if (document.activeElement === this.lastFocusableEl) {
      e.preventDefault();
      this.firstFocusableEl.focus();
    }
  }

  keydown(e) {
    switch (e.key) {
      case KEY_CODES.ESCAPE:
      case KEY_CODES.ESCAPE_IE11:
        this.close();
        break;

      case KEY_CODES.TAB:
        if (this.focusableEls.length === 1) {
          e.preventDefault();
          break;
        }
        if (e.shiftKey) {
          this.handleBackwardTab(e);
        } else {
          this.handleForwardTab(e);
        }
        break;

      default:
        break;
    }
  }
}

export default Menu;
